import React, { useEffect, useState, useRef } from 'react';
import { Translation } from 'react-i18next';
import useWindowDimensions from '../../../../../lib/WindowDimensions';
import Logger from '../../../../../lib/Logger';
import LearningAdminModuleCardLarge from '../containers/LearningAdminModuleCardLargeContainer';
import LearningAdminModuleCardShort from '../containers/LearningAdminModuleCardShortContainer';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Typography } from 'antd';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const { Title } = Typography;

const settings = {
  dots: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,
  className: 'learning-module-list-slider-container',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
      },
    },
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
        dots: false,
      },
    },
  ],
};

const LearningAdminModuleSerieModalModules = ({
  moduleSerieId,
  partnershipId,
  load,
  patch,
  value,
  defaultLimit,
  defaultOrder,
  defaultScope,
  moduleSerieTitle,
  debouncedQuery,
  selectedTags,
  isVisible,
  trackerActions,
  ...props
}) => {
  const { width } = useWindowDimensions();
  const isMedium = 768 <= width;

  const [modules, setModules] = useState([]);
  const sliderRef = useRef(null);

  useEffect(() => {
    const filter = {};
    let searchParams = 0;
    if (debouncedQuery.trim() !== '') {
      filter['keyword'] = debouncedQuery;
      searchParams += 1;
    }

    if (selectedTags.length > 0) {
      filter['categories'] = selectedTags.join(',');
      searchParams += 1;
    }

    if (searchParams > 0) {
      trackerActions(
        mixpanelEventsEnum.ACTIONS_PARTNER.LEARNINGS_ADMIN_PREVIEW_SEARCH
      );
    }

    filter['public_status'] = 1;

    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.LEARNINGS_ADMIN_PREVIEW_SEARCH
    );

    load(
      partnershipId,
      moduleSerieId,
      filter,
      1,
      defaultLimit,
      defaultOrder,
      defaultScope,
      (success, result) => {
        if (success) {
          setModules(result);
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnershipId, moduleSerieId, load, debouncedQuery, selectedTags]);

  useEffect(() => {
    if (isVisible && modules.length > 0 && sliderRef.current?.innerSlider) {
      const id = setTimeout(() => {
        sliderRef.current.innerSlider.onWindowResized();
      }, 0);
      return () => clearTimeout(id);
    }
  }, [isVisible, modules.length, width]);

  if (!isVisible) return null;

  return (
    <Translation>
      {(t) => (
        <>
          {modules.length > 0 && (
            <>
              <Title level={3} className='learning-module-title'>
                {moduleSerieTitle}
              </Title>
            </>
          )}

          {isMedium ? (
            <>
              {modules.length < 3 && (
                <div className='learning-module-list-unique-container'>
                  {modules.map((x) => (
                    <LearningAdminModuleCardLarge item={x} />
                  ))}
                </div>
              )}

              <div>
                {modules.length > 1 &&
                  modules.length !== 2 &&
                  modules.length !== 1 && (
                    <div className='slider-container'>
                      <Slider ref={sliderRef} {...settings}>
                        {modules.map((x) => (
                          <LearningAdminModuleCardShort item={x} />
                        ))}
                      </Slider>
                    </div>
                  )}
              </div>
            </>
          ) : (
            <>
              {modules.length < 2 && (
                <>
                  <div className='learning-module-list-container-mobile'>
                    {modules.map((x) => (
                      <LearningAdminModuleCardShort item={x} />
                    ))}
                  </div>
                </>
              )}

              <div>
                {modules.length > 1 && (
                  <div className='slider-container'>
                    <Slider ref={sliderRef} {...settings}>
                      {modules.map((x) => (
                        <LearningAdminModuleCardShort item={x} />
                      ))}
                    </Slider>
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
    </Translation>
  );
};

export default LearningAdminModuleSerieModalModules;

Logger.log('silly', `LearningAdminModuleSerieModalModules loaded.`);
